"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.invoke = invoke;
var _index = require("../stdlib/index");
function invoke(queryFn, params) {
    if (typeof queryFn === 'undefined') {
        throw new Error('invoke is missing the first argument - it must be a query or mutation function');
    }
    if (_index.isClient) {
        const fn = queryFn;
        return fn(params, {
            fromInvoke: true
        });
    } else {
        const fn = queryFn;
        return fn(params);
    }
}

//# sourceMappingURL=invoke.js.map